import type { CSSProperties } from "react"
import { Gamepad2 } from "lucide-react"
import { cn } from "@/lib/utils"
import { getGameLibraryArtwork } from "@/lib/game-library-artwork"
import styles from "./game-library-artwork.module.css"

interface GameLibraryArtworkProps {
  categorySlug: string
  gameSlug?: string
  className?: string
}

export function GameLibraryArtwork({
  categorySlug,
  gameSlug,
  className,
}: GameLibraryArtworkProps) {
  const artwork = getGameLibraryArtwork(categorySlug, gameSlug)

  if (!artwork) {
    return <Gamepad2 className={className} aria-hidden="true" />
  }

  const column = artwork.index % 4
  const row = Math.floor(artwork.index / 4)

  return (
    <span
      className={cn(styles.artwork, className)}
      data-game-library-artwork=""
      style={
        {
          "--library-atlas-image": `url("${artwork.atlas}")`,
          "--library-atlas-x": `${(column / 3) * 100}%`,
          "--library-atlas-y": `${(row / 3) * 100}%`,
          "--library-artwork-offset-x": `${artwork.offsetX ?? 0}%`,
          "--library-artwork-offset-y": `${artwork.offsetY ?? 0}%`,
        } as CSSProperties
      }
      aria-hidden="true"
    />
  )
}

